import * as React from "react";
import clsx from "clsx";

import IcnChevronDown from "@assets/icons/chevron-down-sharp.svg";

import styles from "./select-component.module.scss";
import { IconComponent } from "../icon";

export interface ISelectComponentProps {
  id: string;
  icon?: string;
  iconSize?: string;
  onSelect: (value: string) => void;
  options: string[];
  isRounded?: boolean;
  variant?: "white" | "default";
}

const SelectComponent = (props: ISelectComponentProps) => {
  const variant = props.variant ?? "default";

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    props.onSelect(newValue);
  };

  return (
    <div className={clsx(styles.select, props.isRounded && styles.rounded, styles[`select--${variant}`])}>
      <select
        id={props.id}
        aria-label="Select"
        className={styles["select-title"]}
        onChange={handleChange}
        onSelect={() => props.onSelect}
      >
        {props.options.map((value, index) => (
          <option aria-selected value={value} key={index}>
            {value}
          </option>
        ))}
      </select>

      <span className={styles[`select--${variant}-icon`]}>
        <IconComponent icon={props.icon || IcnChevronDown} size={props.iconSize || "16px"} />
      </span>
    </div>
  );
};

export { SelectComponent };
